/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";

const PatientPrescription = () => {
  const auth = useSelector((state) => state.auth);
  const bookinglistdata = useSelector((state) => state.bookinglistdata);

  const [accepted, setAccepted] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [activeTab, setActiveTab] = useState("1");

  const [modalOpen, setModalOpen] = useState(false);
  const [prescriptions, setPrescriptions] = useState([]);

  const [searchDate, setSearchDate] = useState(""); // for date filtering

  useEffect(() => {
    if (auth?.info?.uid && bookinglistdata?.bookings) {
      const myBookings = bookinglistdata.bookings.filter(
        (b) => b.patient === auth.info.uid
      );

      setAccepted(myBookings.filter((b) => b.status === "ACCEPTED"));
      setCompleted(myBookings.filter((b) => b.status === "COMPLETE"));
    }
  }, [auth?.info?.uid, bookinglistdata?.bookings]);

  const openModal = (booking) => {
    setPrescriptions(booking.prescription || []);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setPrescriptions([]);
  };

  const renderBooking = (booking, i) => {
    const hasPrescriptions = booking.prescription && booking.prescription.length > 0;

    return (
      <Col md="4" key={i} style={{ marginBottom: "20px" }}>
        <Card style={{ borderRadius: 12, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
          <CardHeader>
            <CardTitle tag="h5">Booking</CardTitle>
          </CardHeader>
          <CardBody>
            <FormGroup>
              <span>Status:</span>
              <p className="description">{booking.status}</p>
            </FormGroup>
            <FormGroup>
              <span>Date:</span>
              <p className="description">{booking.adjustedtimeStart || booking.eventDate}</p>
            </FormGroup>
            <FormGroup>
              <span>Service:</span>
              <p className="description">{booking.serviceType}</p>
            </FormGroup>

            <FormGroup>
              <span>Prescriptions:</span>
              {hasPrescriptions ? (
                <p className="description" style={{ color: "green", fontWeight: "600" }}>
                  {booking.prescription.length} available
                </p>
              ) : (
                <p className="description" style={{ color: "red" }}>None</p>
              )}
            </FormGroup>

            {hasPrescriptions && (
              <Button color="primary" onClick={() => openModal(booking)}>
                View Prescriptions
              </Button>
            )}
          </CardBody>
        </Card>
      </Col>
    );
  };

  // Filter bookings by searchDate
  const filteredAccepted = accepted.filter((b) =>
    !searchDate || (b.adjustedtimeStart || b.eventDate).startsWith(searchDate)
  );
  const filteredCompleted = completed.filter((b) =>
    !searchDate || (b.adjustedtimeStart || b.eventDate).startsWith(searchDate)
  );

  return (
    <div className="content">
      <Card>
        <CardHeader>
          <CardTitle tag="h4">My Prescriptions</CardTitle>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => setActiveTab("1")}
                style={{
                  cursor: "pointer",
                  backgroundColor: activeTab === "1" ? "#28a745" : "transparent",
                  color: activeTab === "1" ? "#fff" : "#28a745",
                  fontWeight: 600,
                  borderRadius: 6,
                  marginRight: 8,
                }}
              >
                Accepted ({accepted.length})
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => setActiveTab("2")}
                style={{
                  cursor: "pointer",
                  backgroundColor: activeTab === "2" ? "#007bff" : "transparent",
                  color: activeTab === "2" ? "#fff" : "#007bff",
                  fontWeight: 600,
                  borderRadius: 6,
                }}
              >
                Completed ({completed.length})
              </NavLink>
            </NavItem>
          </Nav>

          {/* Search Bar */}
          <div style={{ marginTop: "15px", display: "flex", alignItems: "center", gap: "10px" }}>
            <label htmlFor="searchDate"><strong>Filter by Date:</strong></label>
            <input
              id="searchDate"
              type="date"
              value={searchDate}
              onChange={(e) => setSearchDate(e.target.value)}
              style={{ padding: "5px 10px", borderRadius: "5px", border: "1px solid #ccc" }}
            />
            {searchDate && (
              <Button color="secondary" onClick={() => setSearchDate("")}>
                Clear
              </Button>
            )}
          </div>
        </CardHeader>

        <CardBody>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Row>
                {filteredAccepted.length > 0 ? (
                  filteredAccepted.map((b, i) => renderBooking(b, i))
                ) : (
                  <Col md="12">
                    <p>No accepted bookings found.</p>
                  </Col>
                )}
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row>
                {filteredCompleted.length > 0 ? (
                  filteredCompleted.map((b, i) => renderBooking(b, i))
                ) : (
                  <Col md="12">
                    <p>No completed bookings found.</p>
                  </Col>
                )}
              </Row>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>

      {/* Prescription Modal */}
      <Modal isOpen={modalOpen} size="lg" centered>
        <ModalHeader>Prescriptions</ModalHeader>
        <ModalBody style={{ backgroundColor: "#f0f8ff" }}>
          {prescriptions && prescriptions.length > 0 ? (
            <Row>
              {prescriptions.map((p, idx) => (
                <Col md="6" key={idx} style={{ marginBottom: "15px" }}>
                  <Card body style={{ background: "#fff", borderRadius: 8 }}>
                    <p><strong>Drug:</strong> {p.drug_concept_id?.join(", ")}</p>
                    <p><strong>Dose:</strong> {p.dose_unit_source_value}</p>
                    <p><strong>Route:</strong> {p.route_source_value?.join(", ")}</p>
                    <p><strong>Start Date:</strong> {p.drug_exposure_start_date}</p>
                    <p><strong>Source:</strong> {p.drug_source_value?.join(", ")}</p>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <p>No prescriptions for this booking.</p>
          )}
          <Button color="secondary" onClick={closeModal} style={{ marginTop: "15px" }}>
            Back
          </Button>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default PatientPrescription;
